import {
    Vue, Component,
} from 'vue-property-decorator';
import { get } from 'lodash/object';

/**
 * Helpers
 */
@Component
class Helpers extends Vue {
    /**
     * Size properties.
     * 
     * @example
     *  responsive = {
     *      button: {
     *          360: 'xtiny',
     *          450: 'small',
     *          768: 'large',
     *      },
     *  }
     */
    responsive = {}

    /**
     * Return value base on your device size
     * 
     * @param {string} element
     * @param {string} defaultValue
     * @returns {string}
     */
    onSize(element: string = '', defaultValue: string = ''): string {
        let result = defaultValue;
        const el = this.responsive[element];

        const ordered = Object.keys(el).sort().reduce(
            (obj, key) => {
                // eslint-disable-next-line no-param-reassign
                obj[key] = el[key];
                return obj;
            }, {},
        );

        try {
            // eslint-disable-next-line consistent-return
            Object.keys(ordered).forEach((size) => {
                if (window.innerWidth < parseInt(size, 10)) {
                    result = el[size];
                    
                    // eslint-disable-next-line new-cap
                    throw new el();
                }
            });
        } catch {
            return result;
        }

        return result;
    }

    /**
     * Return best version of image
     *
     * @param {object|Array} img
     * @param {string} imageVersion
     * @returns {string}
     */
    imgSrc(img: any, imageVersion: string): string {
        if (Array.isArray(img)) {
            return get(img, `0.versions.${imageVersion}`, img[0].link);
        }
        return get(img, `versions.${imageVersion}`, img.link);
    }
}

export default Helpers;
